
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34474',
  depVersions: {
  "documents-public-ui": "static-1.34474",
  "client-types": "static-1.466",
  "documents-lib": "static-1.34479",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2123",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5583",
  "hs-test-utils": "static-1.8003",
  "hub-http": "static-1.6213",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11459",
  "I18n": "static-7.1621",
  "jasmine-immutable": "static-1.3011",
  "jasmine-runner": "static-1.6456",
  "lodash": "static-1.3",
  "quartz": "static-1.7017",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16657",
  "reporting-data": "static-1.67497",
  "reporting-testing-lib": "static-1.9430",
  "reporting-visualizations": "static-1.59573",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4754",
  "webpack-env": "static-1.54",
  "atom": "static-1.5060",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2488",
  "classnames": "static-2.10",
  "cssUtils": "static-1.787",
  "customer-data-filters-ui": "static-1.39718",
  "customer-data-objects": "static-1.7656",
  "customer-data-property-utils": "static-1.8078",
  "data-fetching-client": "static-1.9660",
  "enviro": "static-4.446",
  "FireAlarmUi": "static-1.4503",
  "flux-actions": "static-1.336",
  "FormsCommonComponents": "static-1.85812",
  "FormUrlGenerator": "static-2.4707",
  "foundations-components": "static-1.7910",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11766",
  "icons": "static-2.645",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7147",
  "metrics-js": "static-1.9619",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.397",
  "property-description-translator": "static-1.3834",
  "property-translator": "static-1.5389",
  "quartz-config": "static-1.795",
  "quartz-core": "static-1.6236",
  "quick-fetch": "static-1.3907",
  "raven": "static-3.5907",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5335",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8158",
  "reference-resolvers-lite": "static-1.8083",
  "report-customization-components": "static-1.13125",
  "reporting-enablement": "static-1.22880",
  "reporting-reports": "static-1.67175",
  "reporting-snowflake": "static-1.56115",
  "reporting-ui-components": "static-2.64768",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4640",
  "sales-content-partitioning": "static-1.8932",
  "SalesContentIndexUI": "static-3.9222",
  "sanitize": "static-1.4466",
  "sanitize-text": "static-1.8131",
  "self-service-api": "static-1.10238",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1738",
  "signup-constants": "static-1.18817",
  "signup-ui-lego-core": "static-1.20827",
  "signup-ui-url-generator": "static-2.8036",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4752",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10982",
  "ui-addon-i18n": "static-1.11140",
  "ui-addon-react-router-dom": "static-1.9533",
  "ui-addon-upgrades": "static-9.17967",
  "ui-asset-management-lib": "static-1.11007",
  "ui-images": "static-2.1150",
  "UIComponents": "static-3.8405",
  "usage-tracker": "static-1.7333",
  "usage-tracker-container": "static-1.7323",
  "usage-tracker-core": "static-1.7183",
  "usage-tracker-public": "static-1.7144",
  "viral-links-lib": "static-1.7051",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3391",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3294",
  "quartz-webpack": "static-1.3241",
  "ai-components-ui-library": "static-1.8917",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4854",
  "foundations-theming": "static-1.4407",
  "quartz-auth": "static-1.692",
  "ui-business-units-lib": "static-1.9039",
  "usage-tracker-session-replay": "static-1.5019",
  "foundations-theming-base": "static-1.3392",
  "HeadJS": "static-2.757",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3114",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.72",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4317",
  "csstype": "static-1.50",
  "quartz-head": "static-1.682",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7919",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3577",
  "persist-promise": "static-1.3687",
  "quartz-i18n": "static-1.692",
  "reporting-client-types": "static-1.2499",
  "foundations-components-legacy": "static-1.935",
  "hs-story-utils": "static-1.9416",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9937",
  "hubspotter-http": "static-1.4643",
  "sassPrefix": "static-1.155",
  "events-data-lib": "static-1.206",
  "conversations-skeleton-state": "static-1.7236",
  "crm-message-bus": "static-1.42956",
  "customer-data-filters-ui-msw-helpers": "static-1.22153",
  "customer-data-objects-ui-components": "static-1.13015",
  "customer-data-reference-ui-components": "static-1.13151",
  "customer-data-ui-utilities": "static-1.9816",
  "framework-builder-read-service-client": "static-1.3996",
  "framework-data-schema-quick-fetch": "static-1.6778",
  "framework-data-schema-resolvers": "static-1.6873",
  "inbound-db-properties-service-client": "static-1.3837",
  "multi-account-reference-resolvers": "static-1.968",
  "onboarding-tours": "static-1.16571",
  "reporting-datasets-permissions-lib": "static-1.13647",
  "ui-addon-teams": "static-1.21527",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68324",
  "customer-data-properties": "static-1.51501",
  "forms-ai-lib": "static-1.4302",
  "forms-utils-lib": "static-1.12556",
  "foundations-components-test-utils": "static-1.5393",
  "react-dnd-compat": "static-1.4606",
  "react-tinymce": "static-1.55208",
  "tinymce-config": "static-2.54334",
  "ui-gdpr-components": "static-1.10338",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4179",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.19",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1878",
  "ui-fonts": "static-1.721",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "mobile-manifest-mixins": "static-1.532",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.447",
  "quartz-test": "static-1.692",
  "quartz-tracking": "static-1.396",
  "batch-promise": "static-1.1530",
  "external-options-client-types": "static-1.4149",
  "react-colorpicker": "static-2.10198",
  "ui-addon-draggable-compat": "static-2.4245",
  "copilot-toolkit": "static-1.11105",
  "data-quality-ui-library": "static-1.12987",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6451",
  "reporting-action-components": "static-1.41265",
  "reporting-filters": "static-1.293",
  "reporting-insights-lib": "static-1.1713",
  "reporting-plugins": "static-1.10306",
  "ui-addon-opt": "static-4.8358",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25345",
  "hubspot-apollo-client": "static-1.4867",
  "bend-plugin-chirp-manifest": "static-1.50",
  "chirp-fetch": "static-1.1875",
  "sales-templates-service-types-lib": "static-1.4161",
  "merchandise-lib": "static-1.263",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5860",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4071",
  "nested-table": "static-1.216",
  "timezone-utils": "static-2.5233",
  "bender-build-tools": "static-1.3186",
  "chatspot-core": "static-1.21239",
  "bend-plugin-foundations-theming": "static-1.2890",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9935",
  "hs-resources": "static-1.145",
  "pulse": "static-1.562",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3788",
  "crm-pipelines-api-client-types": "static-1.4129",
  "multi-currency-client-types": "static-1.3682",
  "getting-started-shared-tasks": "static-1.18464",
  "growth-data-modal": "static-1.5411",
  "growth-onboarding-confetti": "static-1.3056",
  "growth-onboarding-next-action-utils": "static-1.1890",
  "navigation-components": "static-1.17995",
  "onboarding-tours-client": "static-1.4785",
  "onboarding-tours-utils": "static-1.637",
  "ui-shepherd-react": "static-3.10150",
  "ui-shepherd-tracker": "static-1.7531",
  "ui-universal-auth": "static-1.8964",
  "user-context": "static-1.5093",
  "cms-field-types": "static-1.4800",
  "content-icons-ui": "static-1.2222",
  "integrations-lib": "static-1.16089",
  "calling-global-api": "static-1.64475",
  "calling-internal-common": "static-1.31290",
  "calling-lifecycle-internal": "static-1.65857",
  "calling-lifecycle-messages": "static-1.58151",
  "commerce-products-lib": "static-1.9501",
  "crm-links": "static-1.6276",
  "customer-data-properties-shared-msw-handlers": "static-1.9264",
  "file-manager-components": "static-1.23590",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4214",
  "meetings-icalendar-utils-lib": "static-1.620",
  "object-builder-ui-client": "static-1.48701",
  "pipeline-validation-client-types": "static-1.3956",
  "property-value-citations": "static-1.2115",
  "smart-property-lib": "static-1.6898",
  "tiered-pricing": "static-1.1181",
  "ui-addon-iframeable": "static-1.9045",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19811",
  "tinymce-themes": "static-1.56304",
  "data-token-picker": "static-1.16388",
  "hub-http-contrib": "static-1.3032",
  "interframe": "static-3.4749",
  "tinymce-data": "static-1.40419",
  "tinymce-plugins": "static-1.57448",
  "ui-addon-sales-email": "static-1.5201",
  "magpie-lib": "static-1.5546",
  "magpie-types": "static-1.5006",
  "simple-logging-lib": "static-1.3038",
  "content-assistance-lib": "static-1.7734",
  "dashboard-lib": "static-1.81484",
  "ExportDialog": "static-6.10381",
  "hubspot-prosemirror": "static-1.18211",
  "hubspot-prosemirror-plugins": "static-1.18203",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8693",
  "campaign-roi-lib": "static-1.9071",
  "feedback-loader": "static-1.29275",
  "apollo-link-hub-http": "static-2.4639",
  "hubspot-apollo-cache": "static-1.326",
  "purchase-motions-api": "static-1.5863",
  "trials-service-types": "static-1.3893",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.162",
  "markdown-it": "static-1.6",
  "bend-plugin-pulse": "static-1.65",
  "directed-graph": "static-1.924",
  "event-emitter": "static-1.937",
  "fast-json-patch": "static-1.62",
  "onboarding-data-sync-lib": "static-1.1939",
  "growth-onboarding-next-action-components": "static-1.1918",
  "user-context-client": "static-1.4601",
  "idb-keyval": "static-1.43",
  "nest": "static-1.215",
  "reactive-lib": "static-1.713",
  "unified-auth-core-lib": "static-1.760",
  "getting-started-shared-tasks-store": "static-1.17582",
  "integrations-error-boundary-lib": "static-1.13504",
  "integrations-tracking-lib": "static-1.5589",
  "native-integrations-shared-strings": "static-1.7772",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10357",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.478",
  "calling-error-reporting": "static-1.31297",
  "shared-worker-versioning": "static-1.11026",
  "calling-usage-tracker": "static-1.6530",
  "voice-sms-access-library": "static-1.937",
  "customer-data-tracking": "static-1.6877",
  "commerce-permissions": "static-1.758",
  "products-iframe-lib": "static-1.7899",
  "products-ui-components-shared-msw-handlers": "static-1.10319",
  "location-customization-utils-lib": "static-1.9220",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4144",
  "video-components-external": "static-1.11228",
  "video-data-lib": "static-1.34886",
  "data-agent-kit": "static-1.177",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10020",
  "fsm": "static-1.3720",
  "policy-lib": "static-1.6769",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10083",
  "navigation-messaging": "static-1.7322",
  "FileManagerLib": "static-1.39230",
  "NamespacedHubStyle": "static-2.9050",
  "FileManagerCore": "static-1.39089",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12425",
  "layout-dnd-utils": "static-1.11400",
  "react-codemirror": "static-1.10615",
  "ui-addon-emoji-picker": "static-1.9878",
  "ui-brand-identity-lib": "static-1.15233",
  "ui-addon-video-player": "static-1.8692",
  "ui-coaching-tips": "static-1.28520",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23499",
  "EmailSignatureEditor": "static-1.24339",
  "breeze-engine-lib": "static-1.587",
  "InboxConnectUtils": "static-4.14778",
  "universal-page-editor-lib": "static-1.3003",
  "google-sheets-integration-lib": "static-1.202",
  "microsoft-drive-integration-lib": "static-1.322",
  "calling-orchestration-schema": "static-1.35714",
  "sales-views-client-types": "static-1.4251",
  "crm-record-cards-service-types": "static-1.3587",
  "content-media-composition-data-lib": "static-1.12218",
  "content-media-compositions": "static-2.16225",
  "media-bridge-lib": "static-1.18906",
  "trellis-story-utils": "static-1.4506",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5898",
  "FileManagerImages": "static-1.36741",
  "video-components": "static-1.13231",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4526",
  "video-embed": "static-1.35720",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68399",
  "layout-data-lib": "static-1.9725",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6570",
  "commerce-tours-lib": "static-1.6069",
  "growth-onboarding-reliability": "static-1.5071",
  "sales-checkout-service-client": "static-1.3630",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21654",
  "sales-email-signature-service-client": "static-1.3832",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22058",
  "outpost": "static-1.4173",
  "advanced-menus-core": "static-1.15109",
  "advanced-menus-lib": "static-1.12052",
  "ui-memberships-settings-lib": "static-1.34014",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15108",
  "simple-menus-lib": "static-1.16625"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34474",
  "client-types": "/client-types/static-1.466",
  "documents-lib": "/documents-lib/static-1.34479",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2123",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5583",
  "hs-test-utils": "/hs-test-utils/static-1.8003",
  "hub-http": "/hub-http/static-1.6213",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11459",
  "I18n": "/I18n/static-7.1621",
  "jasmine-immutable": "/jasmine-immutable/static-1.3011",
  "jasmine-runner": "/jasmine-runner/static-1.6456",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.7017",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16657",
  "reporting-data": "/reporting-data/static-1.67497",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9430",
  "reporting-visualizations": "/reporting-visualizations/static-1.59573",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4754",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5060",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2488",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.787",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39718",
  "customer-data-objects": "/customer-data-objects/static-1.7656",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8078",
  "data-fetching-client": "/data-fetching-client/static-1.9660",
  "enviro": "/enviro/static-4.446",
  "FireAlarmUi": "/FireAlarmUi/static-1.4503",
  "flux-actions": "/flux-actions/static-1.336",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85812",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4707",
  "foundations-components": "/foundations-components/static-1.7910",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11766",
  "icons": "/icons/static-2.645",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7147",
  "metrics-js": "/metrics-js/static-1.9619",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "property-description-translator": "/property-description-translator/static-1.3834",
  "property-translator": "/property-translator/static-1.5389",
  "quartz-config": "/quartz-config/static-1.795",
  "quartz-core": "/quartz-core/static-1.6236",
  "quick-fetch": "/quick-fetch/static-1.3907",
  "raven": "/raven/static-3.5907",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5335",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8158",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8083",
  "report-customization-components": "/report-customization-components/static-1.13125",
  "reporting-enablement": "/reporting-enablement/static-1.22880",
  "reporting-reports": "/reporting-reports/static-1.67175",
  "reporting-snowflake": "/reporting-snowflake/static-1.56115",
  "reporting-ui-components": "/reporting-ui-components/static-2.64768",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4640",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8932",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9222",
  "sanitize": "/sanitize/static-1.4466",
  "sanitize-text": "/sanitize-text/static-1.8131",
  "self-service-api": "/self-service-api/static-1.10238",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1738",
  "signup-constants": "/signup-constants/static-1.18817",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20827",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8036",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4752",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10982",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11140",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9533",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17967",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11007",
  "ui-images": "/ui-images/static-2.1150",
  "UIComponents": "/UIComponents/static-3.8405",
  "usage-tracker": "/usage-tracker/static-1.7333",
  "usage-tracker-container": "/usage-tracker-container/static-1.7323",
  "usage-tracker-core": "/usage-tracker-core/static-1.7183",
  "usage-tracker-public": "/usage-tracker-public/static-1.7144",
  "viral-links-lib": "/viral-links-lib/static-1.7051",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3391",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3294",
  "quartz-webpack": "/quartz-webpack/static-1.3241",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8917",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4854",
  "foundations-theming": "/foundations-theming/static-1.4407",
  "quartz-auth": "/quartz-auth/static-1.692",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9039",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5019",
  "foundations-theming-base": "/foundations-theming-base/static-1.3392",
  "HeadJS": "/HeadJS/static-2.757",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3114",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.72",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4317",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.682",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7919",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3577",
  "persist-promise": "/persist-promise/static-1.3687",
  "quartz-i18n": "/quartz-i18n/static-1.692",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.935",
  "hs-story-utils": "/hs-story-utils/static-1.9416",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9937",
  "hubspotter-http": "/hubspotter-http/static-1.4643",
  "sassPrefix": "/sassPrefix/static-1.155",
  "events-data-lib": "/events-data-lib/static-1.206",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7236",
  "crm-message-bus": "/crm-message-bus/static-1.42956",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22153",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13015",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13151",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9816",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3996",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6778",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6873",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3837",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.968",
  "onboarding-tours": "/onboarding-tours/static-1.16571",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13647",
  "ui-addon-teams": "/ui-addon-teams/static-1.21527",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68324",
  "customer-data-properties": "/customer-data-properties/static-1.51501",
  "forms-ai-lib": "/forms-ai-lib/static-1.4302",
  "forms-utils-lib": "/forms-utils-lib/static-1.12556",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5393",
  "react-dnd-compat": "/react-dnd-compat/static-1.4606",
  "react-tinymce": "/react-tinymce/static-1.55208",
  "tinymce-config": "/tinymce-config/static-2.54334",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10338",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4179",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.19",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1878",
  "ui-fonts": "/ui-fonts/static-1.721",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.532",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.447",
  "quartz-test": "/quartz-test/static-1.692",
  "quartz-tracking": "/quartz-tracking/static-1.396",
  "batch-promise": "/batch-promise/static-1.1530",
  "external-options-client-types": "/external-options-client-types/static-1.4149",
  "react-colorpicker": "/react-colorpicker/static-2.10198",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4245",
  "copilot-toolkit": "/copilot-toolkit/static-1.11105",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12987",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6451",
  "reporting-action-components": "/reporting-action-components/static-1.41265",
  "reporting-filters": "/reporting-filters/static-1.293",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1713",
  "reporting-plugins": "/reporting-plugins/static-1.10306",
  "ui-addon-opt": "/ui-addon-opt/static-4.8358",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25345",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4867",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.50",
  "chirp-fetch": "/chirp-fetch/static-1.1875",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4161",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5860",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4071",
  "nested-table": "/nested-table/static-1.216",
  "timezone-utils": "/timezone-utils/static-2.5233",
  "bender-build-tools": "/bender-build-tools/static-1.3186",
  "chatspot-core": "/chatspot-core/static-1.21239",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2890",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9935",
  "hs-resources": "/hs-resources/static-1.145",
  "pulse": "/pulse/static-1.562",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3788",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4129",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3682",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18464",
  "growth-data-modal": "/growth-data-modal/static-1.5411",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3056",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1890",
  "navigation-components": "/navigation-components/static-1.17995",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4785",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.637",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10150",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7531",
  "ui-universal-auth": "/ui-universal-auth/static-1.8964",
  "user-context": "/user-context/static-1.5093",
  "cms-field-types": "/cms-field-types/static-1.4800",
  "content-icons-ui": "/content-icons-ui/static-1.2222",
  "integrations-lib": "/integrations-lib/static-1.16089",
  "calling-global-api": "/calling-global-api/static-1.64475",
  "calling-internal-common": "/calling-internal-common/static-1.31290",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65857",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58151",
  "commerce-products-lib": "/commerce-products-lib/static-1.9501",
  "crm-links": "/crm-links/static-1.6276",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9264",
  "file-manager-components": "/file-manager-components/static-1.23590",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4214",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.620",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48701",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3956",
  "property-value-citations": "/property-value-citations/static-1.2115",
  "smart-property-lib": "/smart-property-lib/static-1.6898",
  "tiered-pricing": "/tiered-pricing/static-1.1181",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9045",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19811",
  "tinymce-themes": "/tinymce-themes/static-1.56304",
  "data-token-picker": "/data-token-picker/static-1.16388",
  "hub-http-contrib": "/hub-http-contrib/static-1.3032",
  "interframe": "/interframe/static-3.4749",
  "tinymce-data": "/tinymce-data/static-1.40419",
  "tinymce-plugins": "/tinymce-plugins/static-1.57448",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5201",
  "magpie-lib": "/magpie-lib/static-1.5546",
  "magpie-types": "/magpie-types/static-1.5006",
  "simple-logging-lib": "/simple-logging-lib/static-1.3038",
  "content-assistance-lib": "/content-assistance-lib/static-1.7734",
  "dashboard-lib": "/dashboard-lib/static-1.81484",
  "ExportDialog": "/ExportDialog/static-6.10381",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18211",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18203",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8693",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9071",
  "feedback-loader": "/feedback-loader/static-1.29275",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4639",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.326",
  "purchase-motions-api": "/purchase-motions-api/static-1.5863",
  "trials-service-types": "/trials-service-types/static-1.3893",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.162",
  "markdown-it": "/markdown-it/static-1.6",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.65",
  "directed-graph": "/directed-graph/static-1.924",
  "event-emitter": "/event-emitter/static-1.937",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1939",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1918",
  "user-context-client": "/user-context-client/static-1.4601",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.215",
  "reactive-lib": "/reactive-lib/static-1.713",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.760",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17582",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13504",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5589",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7772",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10357",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.478",
  "calling-error-reporting": "/calling-error-reporting/static-1.31297",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11026",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6530",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.937",
  "customer-data-tracking": "/customer-data-tracking/static-1.6877",
  "commerce-permissions": "/commerce-permissions/static-1.758",
  "products-iframe-lib": "/products-iframe-lib/static-1.7899",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10319",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9220",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4144",
  "video-components-external": "/video-components-external/static-1.11228",
  "video-data-lib": "/video-data-lib/static-1.34886",
  "data-agent-kit": "/data-agent-kit/static-1.177",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10020",
  "fsm": "/fsm/static-1.3720",
  "policy-lib": "/policy-lib/static-1.6769",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10083",
  "navigation-messaging": "/navigation-messaging/static-1.7322",
  "FileManagerLib": "/FileManagerLib/static-1.39230",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9050",
  "FileManagerCore": "/FileManagerCore/static-1.39089",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12425",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11400",
  "react-codemirror": "/react-codemirror/static-1.10615",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9878",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15233",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8692",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28520",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23499",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24339",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.587",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14778",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3003",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.202",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.322",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35714",
  "sales-views-client-types": "/sales-views-client-types/static-1.4251",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12218",
  "content-media-compositions": "/content-media-compositions/static-2.16225",
  "media-bridge-lib": "/media-bridge-lib/static-1.18906",
  "trellis-story-utils": "/trellis-story-utils/static-1.4506",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5898",
  "FileManagerImages": "/FileManagerImages/static-1.36741",
  "video-components": "/video-components/static-1.13231",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4526",
  "video-embed": "/video-embed/static-1.35720",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68399",
  "layout-data-lib": "/layout-data-lib/static-1.9725",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6570",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6069",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5071",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3630",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21654",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3832",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22058",
  "outpost": "/outpost/static-1.4173",
  "advanced-menus-core": "/advanced-menus-core/static-1.15109",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12052",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34014",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15108",
  "simple-menus-lib": "/simple-menus-lib/static-1.16625"
}
};
